// extracted by mini-css-extract-plugin
export default {"notfoundpage":"error_notfoundpage__bZ52Q","navigate":"error_navigate__dduR8","back":"error_back__lvWyz","contact":"error_contact__PXsI1"};